import { PlanTier } from '../../../app-common/subscriptions/subscription-configuration-models';

/**
 * Whether a licence is one the configuration gives away: its type is a tier
 * that declares no purchase options — the same test `LicenceOptions
 * .RequiresPayment` applies server-side. Nothing on the licence row says so;
 * "free" is a property of the tier, and the tiers travel with the account
 * payload as `purchaseOptions`.
 *
 * Strict on purpose: a type that matches NO tier is not free. A legacy type
 * dropped from the configuration would otherwise read as free and grow an
 * Upgrade button in place of its assignment control.
 */
export function isFreeLicence(licence: { type: string }, tiers: PlanTier[] | null | undefined): boolean {
    return (tiers || []).some(tier =>
        tier.associatedLicenseId === licence.type
        && (!tier.purchaseOptions || tier.purchaseOptions.length === 0));
}
